"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSeverity = exports.PoiTypes = void 0;
var PoiTypes;
(function (PoiTypes) {
    PoiTypes[PoiTypes["tubes"] = 1] = "tubes";
    PoiTypes[PoiTypes["cycles"] = 2] = "cycles";
    PoiTypes[PoiTypes["dlr"] = 3] = "dlr";
    PoiTypes[PoiTypes["trains"] = 4] = "trains";
    PoiTypes[PoiTypes["eCPs"] = 5] = "eCPs";
    PoiTypes[PoiTypes["parking"] = 6] = "parking";
    PoiTypes[PoiTypes["fitness"] = 7] = "fitness";
    PoiTypes[PoiTypes["greenSpaces"] = 8] = "greenSpaces";
    PoiTypes[PoiTypes["walks"] = 9] = "walks";
    PoiTypes[PoiTypes["restaurants"] = 10] = "restaurants";
    PoiTypes[PoiTypes["barsAndPubs"] = 11] = "barsAndPubs";
    PoiTypes[PoiTypes["lodging"] = 12] = "lodging";
    PoiTypes[PoiTypes["cinemas"] = 13] = "cinemas";
    PoiTypes[PoiTypes["theatres"] = 14] = "theatres";
})(PoiTypes || (PoiTypes = {}));
exports.PoiTypes = PoiTypes;
var LinkGroups;
(function (LinkGroups) {
    LinkGroups[LinkGroups["services"] = 1] = "services";
    LinkGroups[LinkGroups["leisure"] = 2] = "leisure";
    LinkGroups[LinkGroups["fitness"] = 3] = "fitness";
    LinkGroups[LinkGroups["disabledAccess"] = 4] = "disabledAccess";
    LinkGroups[LinkGroups["charities"] = 5] = "charities";
})(LinkGroups || (LinkGroups = {}));
var LinkTypes;
(function (LinkTypes) {
    LinkTypes[LinkTypes["hotels"] = 1] = "hotels";
    LinkTypes[LinkTypes["dryCleaning"] = 2] = "dryCleaning";
    LinkTypes[LinkTypes["freshFruitAndVeg"] = 3] = "freshFruitAndVeg";
    LinkTypes[LinkTypes["lunch"] = 4] = "lunch";
    LinkTypes[LinkTypes["barsAndPubs"] = 5] = "barsAndPubs";
    LinkTypes[LinkTypes["comedy"] = 6] = "comedy";
    LinkTypes[LinkTypes["karaoke"] = 7] = "karaoke";
    LinkTypes[LinkTypes["theatre"] = 8] = "theatre";
    LinkTypes[LinkTypes["swimming"] = 9] = "swimming";
    LinkTypes[LinkTypes["football"] = 10] = "football";
    LinkTypes[LinkTypes["yoga"] = 11] = "yoga";
    LinkTypes[LinkTypes["climbing"] = 12] = "climbing";
    LinkTypes[LinkTypes["accessibleServices"] = 13] = "accessibleServices";
    LinkTypes[LinkTypes["accessibleParking"] = 14] = "accessibleParking";
    LinkTypes[LinkTypes["environment"] = 15] = "environment";
    LinkTypes[LinkTypes["children"] = 16] = "children";
    LinkTypes[LinkTypes["uk"] = 17] = "uk";
    LinkTypes[LinkTypes["international"] = 18] = "international";
})(LinkTypes || (LinkTypes = {}));
var StatusSeverity;
(function (StatusSeverity) {
    StatusSeverity[StatusSeverity["Closed"] = 1] = "Closed";
    StatusSeverity[StatusSeverity["Suspended"] = 2] = "Suspended";
    StatusSeverity[StatusSeverity["PartSuspended"] = 3] = "PartSuspended";
    StatusSeverity[StatusSeverity["PlannedClosure"] = 4] = "PlannedClosure";
    StatusSeverity[StatusSeverity["PartClosure"] = 5] = "PartClosure";
    StatusSeverity[StatusSeverity["SevereDelays"] = 6] = "SevereDelays";
    StatusSeverity[StatusSeverity["ReducedService"] = 7] = "ReducedService";
    StatusSeverity[StatusSeverity["BusService"] = 8] = "BusService";
    StatusSeverity[StatusSeverity["MinorDelays"] = 9] = "MinorDelays";
    StatusSeverity[StatusSeverity["GoodService"] = 10] = "GoodService";
})(StatusSeverity || (StatusSeverity = {}));
exports.StatusSeverity = StatusSeverity;
//# sourceMappingURL=MarkerTypes.js.map